import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconAsana({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M12.52 8.33a3.48 3.48 0 1 0 0 6.959 3.48 3.48 0 0 0 0-6.96zm-9.04 0a3.48 3.48 0 1 0 0 6.959 3.48 3.48 0 0 0 0-6.96zm8-4.35a3.48 3.48 0 1 1-6.96 0 3.48 3.48 0 0 1 6.96 0z"/>
        </svg>
    );
}

export default IconAsana;
